import { useState } from "react";
import { Check, X } from "lucide-react";
import { toast } from "sonner";
import { errMsg } from "./useAuthedHttp";

export const SuggestionRow = ({ s, call, onDone, readOnly }) => {
  const [value, setValue] = useState(s.final || s.suggestion);
  const act = async (kind) => {
    try {
      await call("post", `/translations/suggestions/${s.id}/${kind}`, kind === "accept" ? { value } : {});
      toast.success(kind === "accept" ? "Accepted and live" : "Rejected");
      onDone(s.id);
    } catch (e) { toast.error(errMsg(e, "Action failed")); }
  };
  return (
    <li className="rounded-2xl bg-white border border-[#1C242B]/10 p-5" data-testid={`suggestion-${s.id}`}>
      <p className="text-xs font-mono-ui text-slate-500">{s.lang.toUpperCase()} · {s.kind} · {s.page} · {s.created_at?.slice(0, 10)}</p>
      <p className="mt-2 text-sm"><b>English:</b> {s.source}</p>
      <p className="mt-1 text-sm text-slate-600"><b>Current:</b> {s.current}</p>
      {s.note && <p className="mt-1 text-sm text-slate-500"><b>Note:</b> {s.note}</p>}
      <textarea value={value} onChange={(e) => setValue(e.target.value)} rows={2} readOnly={readOnly} data-testid={`suggestion-value-${s.id}`}
        className="mt-3 w-full rounded-xl border border-[#1C242B]/15 bg-[#FAF8F5] p-3 text-sm" />
      {!readOnly && (
        <div className="mt-3 flex gap-2">
          <button onClick={() => act("accept")} data-testid={`suggestion-accept-${s.id}`} className="inline-flex items-center gap-1.5 rounded-full bg-[#3E6B5C] text-white px-4 py-2 text-sm hover:bg-[#2f5447] transition-colors"><Check size={14} /> Accept</button>
          <button onClick={() => act("reject")} data-testid={`suggestion-reject-${s.id}`} className="inline-flex items-center gap-1.5 rounded-full border border-[#1C242B]/15 px-4 py-2 text-sm hover:bg-[#1C242B]/5 transition-colors"><X size={14} /> Reject</button>
        </div>
      )}
    </li>
  );
};
